import React from 'react';
import Cookies from 'js-cookie';
import { Form, Input, InputNumber, Select, Switch, Radio, Checkbox, DatePicker, TimePicker, Rate, Icon, Button, Tooltip } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import './index.less';

const FormItem = Form.Item;
const { TextArea, Search, } = Input;
const { Option, } = Select;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const { MonthPicker, RangePicker, WeekPicker } = DatePicker;

class SuperForm extends React.Component {
    static propTypes = {
        data: PropTypes.array.isRequired,
        sumbit: PropTypes.func.isRequired,
        attribute: PropTypes.object,
        showConfirm: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        showCancel: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        showCancelFn: PropTypes.func,
        saveReset: PropTypes.bool,
        addParams: PropTypes.string,
    };

    static defaultProps = {
        addParams: 'page'
    }

    state = {}

    render() {
        /**
         * @params{data}             #数据【data配置请参考事例】
         * @params{attribute}        #form的标签属性
         * @params{showConfirm}      #显示查询按钮【更改可替换文字】，设置false可不显示按钮
         * @params{showCancel}       #显示重置按钮【更改可替换文字】，设置false可不显示按钮
         * @params{showCancelFn}     #重置按钮的回调，不传使用确定按钮的回调
         * @params{saveReset}        #在点击【确定】按钮之后是否重置表单
         * @params{addParams}        #在sumbit返回参数时是否需要加上[addParams]=1
         */
        const { data, attribute, form, showConfirm = "查询", showCancel = "重置", showCancelFn } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Form onSubmit={this.handleSubmit.bind(this)} {...attribute} layout={"inline"}>
                <div className="superFormWrap">
                    <div className="entry">
                        {data.map(item => this.createFormDOM(item, getFieldDecorator))}
                    </div>
                    <div className="btn">
                        {showConfirm ? <Button type="primary" icon="search" htmlType="submit">{showConfirm}</Button> : null}
                        {showCancel ? <Button icon="reload" onClick={() => showCancelFn ? showCancelFn() : this.reset()} style={{ marginLeft: '10px' }}>{showCancel}</Button> : null}
                    </div>
                </div>
            </Form>
        )
    }

    componentDidMount() {
        this.props.onRef && this.props.onRef(this);
    }

    createFormDOM(data, getFieldDecorator) { //创建每一条DOM
        let optionData = JSON.parse(JSON.stringify(data.optionData || [])),   //Select SelectMultiple Radio Checkbox的数据
            formItem = JSON.parse(JSON.stringify(data.formItem || {})),       //FormItem的属性
            formConfig = data.formConfig || {},   //FormItem内getFieldDecorator所需要的配置
            attribute = data.attribute,     //输入组件的属性
            suffix = data.suffix,                                             //后缀DOM
            tagName = data.tagName;                                           //标签常量

        let entryDOM = null;
        switch (tagName) { //其它情况
            case 'Input':
                entryDOM = <Input {...attribute} autoComplete="off" />
                break;
            case 'InputSetting':
                entryDOM = <Input {...attribute} autoComplete="off" addonAfter={<Icon key='setting' style={{ cursor: 'pointer' }} type="setting" />} />
                break;
            case 'InputNumber':
                entryDOM = <InputNumber {...attribute} />
                break;
            case 'TextArea':
                entryDOM = <TextArea {...attribute} />
                break;
            case 'Search':
                entryDOM = <Search {...attribute} />
                break;
            case 'Select':
                if (optionData.length === 0 && formConfig.options)
                    delete formConfig.options.initialValue;
                entryDOM = (
                    <Select showSearch={true} optionFilterProp={'children'} style={{ width: '200px' }} notFoundContent={'暂无数据'} {...attribute} >
                        {optionData.map((item, index) => <Option {...item} key={index} >{item.title}</Option>)}
                    </Select>
                );
                break;
            case 'SelectMultiple':
                entryDOM = (
                    <Select mode={'multiple'} showSearch={true} optionFilterProp={'children'} style={{ width: '200px' }} notFoundContent={'暂无数据'} {...attribute} >
                        {optionData.map((item, index) => <Option {...item} key={index} >{item.title}</Option>)}
                    </Select>
                );
                break;
            case 'Switch':
                entryDOM = <Switch {...attribute} />
                break;
            case 'Radio':
                entryDOM = (
                    <RadioGroup {...attribute} >
                        {optionData.map((item, index) => <Radio {...item} key={index} >{item.title}</Radio>)}
                    </RadioGroup>
                );
                break;
            case 'Checkbox':
                entryDOM = (
                    <CheckboxGroup {...attribute} >
                        {optionData.map((item, index) => <Checkbox {...item} key={index} >{item.title}</Checkbox>)}
                    </CheckboxGroup>
                );
                break;
            case 'DatePicker':
                entryDOM = <DatePicker {...attribute} />
                break;
            case 'MonthPicker':
                entryDOM = <MonthPicker {...attribute} />
                break;
            case 'WeekPicker':
                entryDOM = <WeekPicker {...attribute} />
                break;
            case 'RangePicker':
                entryDOM = <RangePicker {...attribute} />
                break;
            case 'TimePicker':
                entryDOM = <TimePicker {...attribute} />
                break;
            case 'Rate':
                entryDOM = <Rate {...attribute} />
                break;
            case 'InputTip':
                return <FormItem key={formConfig.name} {...formItem} >
                    <Tooltip placement="bottomLeft" title={data.title}>
                        {getFieldDecorator(formConfig.name, formConfig.options)(<Input {...attribute} autoComplete="off" />)}
                        {suffix ? <span className="ant-form-text">{suffix}</span> : null}
                    </Tooltip>
                </FormItem>
            case 'DatePickerEnd':
                return <FormItem style={{ marginLeft: '-8px' }} key={formConfig.name} {...formItem} >
                    <span style={{ paddingRight: '8px' }}>-</span>
                    {getFieldDecorator(formConfig.name, formConfig.options)(<DatePicker {...attribute} />)}
                    {suffix ? <span className="ant-form-text">{suffix}</span> : null}
                </FormItem>
            default:
                entryDOM = null
                break;
        }

        return (
            <FormItem key={formConfig.name} {...formItem} >
                {getFieldDecorator(formConfig.name, formConfig.options)(entryDOM)}
                {suffix ? <span className="ant-form-text">{suffix}</span> : null}
            </FormItem>
        )
    }

    handleSubmit(e) { //提交
        e.preventDefault();
        let { form, data, sumbit, addParams, saveReset } = this.props;

        form.validateFields((err, values) => {
            if (!err) {
                values = this.formatValuesHandle(values, data);
                if (addParams) values[addParams] = 1;
                if (saveReset) form.resetFields();
                sumbit(values);
            }
        });
    }

    reset() { //重置，还有一些情况未考虑，可根据实际情况更改
        let { form, data, sumbit, addParams } = this.props;
        form.resetFields();
        let values = form.getFieldsValue();
        values = this.formatValuesHandle(values, data);
        if (addParams) values[addParams] = 1;
        sumbit(values);
    }

    formatValuesHandle(values, data) { //处理返回值
        console.log("values",values)

        console.log("data,",data)

        // 处理其它值
        for (let i = 0; i < data.length; i++) {
            let name = data[i].formConfig.name;


            if (data[i].tagName === 'Checkbox' || data[i].tagName === 'SelectMultiple') { //复选框 下拉复选框               
                values[name] = values[name] ? values[name].join(',') : '';
            }
            else if (data[i].tagName === 'TimePicker') { //时间选择器
                if (values[name]) {
                    values[name] = values[name]._d ? moment(values[name]._d).format(data[i].attribute.format || 'HH:mm:ss') : '';
                } else {
                    values[name] = '';
                }
            }
            else if (data[i].tagName === 'DatePicker' || data[i].tagName === 'DatePickerEnd') { //日期选择器
                if (values[name]) {
                    values[name] = values[name]._d ? moment(values[name]._d).format(data[i].attribute.format || 'YYYY-MM-DD') : '';
                } else {
                    values[name] = '';
                }
            }
            else if (data[i].tagName === 'WeekPicker') { //周选择器
                if (values[name]) {
                    values[name] = values[name]._d ? `${moment(values[name]._d).weekYear()}-${moment(values[name]._d).week()}` : '';
                } else {
                    values[name] = '';
                }
            }
            else if (data[i].tagName === 'MonthPicker') { //月选择器
                if (values[name]) {
                    values[name] = values[name]._d ? moment(values[name]._d).format(data[i].attribute.format || 'YYYY-MM') : '';
                } else {
                    values[name] = '';
                }
            }
            else if (data[i].tagName === 'RangePicker') { //范围选择器
                let useName = data[i].otherConfig.name;
                if (values[name]) {
                    values[useName[0]] = values[name][0]._d ? moment(values[name][0]._d).format(data[i].attribute.format || 'YYYY-MM-DD') : '';
                    values[useName[1]] = values[name][1]._d ? moment(values[name][1]._d).format(data[i].attribute.format || 'YYYY-MM-DD') : '';
                } else {
                    values[useName[0]] = '';
                    values[useName[1]] = '';
                }
                delete values[name];
            }
            else if (data[i].tagName === 'Select') { //单选下拉框
                values[name] = (values[name] > -1 || typeof values[name] ==='string') ? values[name] : data[i].notResult === undefined ? -1 : data[i].notResult;
            }
            else if (data[i].tagName === 'Input' || data[i].tagName === 'InputTip' || data[i].tagName === 'TextArea' || data[i].tagName === 'Search') { //防止XSS
                values[name] = values[name] || '';
                // values[name] = filterXSS(values[name] || '');
            }
        }

        return values
    }
}

export default Form.create()(SuperForm) 


// WEBPACK FOOTER //
// ./src/components/SuperForm/index.js